export default function labelValue(label, hideLabel, fallback) {
  return hideLabel ? fallback : label;
}